import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import faltVy from '../../../_Common/Components/BusinessCollectionComponents/faltVy';
import AktivitetDokOkjektVyComp from './Components/AktivitetDokObjektVyComp';

const forstaSida: IObjektVy = ObjektVySida(
  'forstaSida',
  [
    [
      objektVyGrupp(
        'Dokumentinfo',
        [faltVy('BESKRIVNING', 'ownblock'), faltVy('EXTENSION', 'ownblock')],
        ''
      ),
    ],
  ],
  1,
  'Dokumentinformation'
);

const AktivitetDokOkjektVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'Document',
  info: { fullscreenInSideBySide: true },
  def: () => AktivitetDokOkjektVyComp,
};

export const aktivitetDok: IObjektVy = standardVy(
  [
    forstaSida,
    ObjektVySida(
      'Aktivitetdokument',
      AktivitetDokOkjektVy,
      2,
      'Dokument',
      undefined,
      true
    ),
  ],
  { sidaVidSida: true, sideBySideWidths: [5, 7] }
);
